import {FavoriteUserType} from '@/Store/community/types';

export const extractId = (users: FavoriteUserType[]): Array<string> => {
  return users.map(el => el.userID);
};
